import { Module, VuexModule, Mutation, Action } from "vuex-module-decorators";
import {
    getLeads,
    createLead,
    convertLead as convertLeadApi,
    editLead,
    viewLeads,
    addNotes,
    sendEmail,
    deleteLead,
} from "@/services/channel";

@Module({
    namespaced: true,
})
export default class Channel extends VuexModule {
    // state
    leadsData: any[] = [];
    leadCreationStatus: number | null = null;
    leadConversionStatus: number | null = null;
    viewLeadData: any = null;
    addNotesStatus: number | null = null;
    sendEmailStatus: number | null = null;
    deleteLeadStatus: number | null = null;

    // mutations
    @Mutation
    SET_LEADS_DATA(data: any[]) {
        this.leadsData = data;
    }

    @Mutation
    SET_LEAD_CREATION_STATUS(status: number) {
        this.leadCreationStatus = status;
    }

    @Mutation
    SET_LEAD_CONVERSION_STATUS(status: number) {
        this.leadConversionStatus = status;
    }

    @Mutation
    SET_VIEW_LEAD_DATA(data: any) {
        this.viewLeadData = data;
    }

    @Mutation
    SET_ADD_NOTES_STATUS(status: number) {
        this.addNotesStatus = status;
    }

    @Mutation
    SET_SEND_EMAIL_STATUS(status: number) {
        this.sendEmailStatus = status;
    }

    @Mutation
    SET_DELETE_LEAD_STATUS(status: number) {
        this.deleteLeadStatus = status;
    }


    // actions
    @Action
    async fetchLeads(payload: any) {
        try {
            const response = await getLeads(payload);
            this.context.commit("SET_LEADS_DATA", response);
            return response;
        } catch (error) {
            console.error("fetchLeads failed", error);
            throw error;
        }
    }

    @Action
    async addLead(payload: any) {
        try {
            const response = await createLead(payload);
            this.context.commit("SET_LEAD_CREATION_STATUS", response.status);
            return response;
        } catch (error) {
            console.error("addLead failed", error);
            throw error;
        }
    }

    @Action
    async convertLeadAction(payload: any) {
        try {
            const response = await convertLeadApi(payload);
            this.context.commit("SET_LEAD_CONVERSION_STATUS", response.status);
            return response;
        } catch (error) {
            console.error("convertLead failed", error);
            throw error;
        }
    }
    @Action
    async editLead(payload: any) {
        try {
            const response = await editLead(payload);
            return response;
        } catch (error) {
            console.error("editLead failed", error);
            throw error;
        }
    }
    @Action
    async viewLead(id: string) {
        try {
            const response = await viewLeads(id);
            this.context.commit("SET_VIEW_LEAD_DATA", response);
            return response;
        } catch (error) {
            console.error("viewLead failed", error);
            throw error;
        }
    }
    @Action
    async addNotesAction(payload: any) {
        try {
            const response = await addNotes(payload);
            this.context.commit("SET_ADD_NOTES_STATUS", response.status);
            return response;
        } catch (error) {
            console.error("addNotes failed", error);
            throw error;
        }
    }
    @Action
    async sendEmailAction(payload: any) {
        try {
            const response = await sendEmail(payload);
            this.context.commit("SET_SEND_EMAIL_STATUS", response.status);
            return response;
        } catch (error) {
            console.error("sendEmail failed", error);
            throw error;
        }
    }

    @Action
    async deleteLeadAction(payload: { id: string; tenant: string }) {
        const response = await deleteLead(payload);
        this.context.commit("SET_DELETE_LEAD_STATUS", response.status);
        return response;
    }

}
